module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_c('p', {
    staticClass: "s5"
  }, [_vm._v("Copyright © 2008 by Adam-Troy Castro"), _c('br'), _vm._v("First published online at "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Helix Speculative Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "s2"
  }, [_vm._v("Revised copyright © 2012 by Adam-Troy Castro"), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "s2"
  }, [_vm._v("Cover design by Eddie Schneider.")]), _vm._v(" "), _c('p', {
    staticClass: "s2"
  }, [_vm._v("Published as an ebook by Jabberwocky Literary Agency, Inc.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83c0da00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0